import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue?vue&type=template&id=a7e9bbe4"
import script from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports